import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
}
export function CTAButton({
  text = '¡SÍ! QUIERO ACCESO INSTANTÁNEO POR $11.99',
  className = ''
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={`relative px-8 py-5 bg-[#d4a853] text-[#0a0a0a] font-bold text-base md:text-lg tracking-wide rounded-sm uppercase cursor-pointer transition-all duration-300 hover:bg-[#c9a227] gold-glow ${className}`} data-id="element-21">
      {text}
    </motion.button>;
}